import { generator } from '@philips-emr/tws-core/lib/client/event-listener';

const HPMSOnAfterSubmitDocumentsCard = generator('onAfterSubmitDocumentsCard');
const HPMSOnMountDocumentsCard = generator('onMountDocumentsCard');

export {
  HPMSOnAfterSubmitDocumentsCard,
  HPMSOnMountDocumentsCard,
};

